<!------- cards----------->
  <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
    <ng-container *ngIf="cargando">
      <div fxLayout="column" fxLayoutAlign="space-between center" >
        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
        <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
      </div>
    </ng-container>

    <ng-container *ngIf="!cargando">
      <ng-container *ngFor="let langStep of langSteps;let i = index;">
        <div class="cursoCard" *ngIf="i == 0 || (i > 0 && numLangs > 1)" fxFlex="100" fxFlex.gt-xs="50" fxFlex.gt-sm="33" [ngClass]="langStep.category" [@animate]="{value:'*',params:{delay:'250ms',y:'25px'}}">

          <div class="course-content" fxLayout="column" fxFlex="1 1 auto">

            <div class="header accent-100" fxLayout="row" fxLayoutAlign="center center">
              <div class="category" fxFlex>
                {{langStep.title | translate}}
              </div>
              <div class="length" fxLayout="row" fxLayoutAlign="center center">
                <mat-icon *ngIf="i == 0 && lang1Ok" class="length-icon done s-40">check_circle</mat-icon>
                <mat-icon *ngIf="i == 1 && lang2Ok" class="length-icon done s-40">check_circle</mat-icon>
              </div>
            </div>

            <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">

              <!--------- card idioma nativo ------->
              <mat-chip-list *ngIf="i == 0" class="mat-chip-list-stacked" aria-label="Color selection" style="width:100%;text-align:center;">
                <p *ngIf="langNat.length === 0">{{'CERTIFICAR.IDIOMAS.CARD1.ACCION.PRE' | translate}}</p>
                <p *ngIf="langNat.length > 0">{{'CERTIFICAR.IDIOMAS.CARD1.ACCION.POST' | translate}}</p>
                <mat-chip
                  *ngFor="let chip of langNat"
                  [color]="chip.color"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="remove(chip.name,1)"
                  style="display:unset;">
                  {{chip.name}}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
              </mat-chip-list>

              <!--------- card resto idiomas ------->
              <mat-chip-list *ngIf="i == 1" class="mat-chip-list-stacked" aria-label="Color selection" style="width:100%;text-align:center;">
                <p *ngIf="langAdic.length === 0 && !sinAdic">{{'CERTIFICAR.IDIOMAS.CARD2.ACCION.PRE' | translate}}</p>
                <mat-checkbox *ngIf="langAdic.length === 0" [(ngModel)]="idSinAdic" (click)="sinAdicionales($event)" id="checkSinAd">
                  {{'CERTIFICAR.IDIOMAS.CARD2.ACCION.SINADIC' | translate}}
                </mat-checkbox>
                <p *ngIf="langAdic.length > 0">{{'CERTIFICAR.IDIOMAS.CARD2.ACCION.POST' | translate}}</p>
                <mat-chip
                  *ngFor="let chip of langAdic"
                  [color]="chip.color"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="remove(chip.name,2)"
                  style="display:unset;">
                  {{chip.name}}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
              </mat-chip-list>

            </div>

            <!------- boton elegir idioma nativo --------->
            <div *ngIf="i == 0" class="footer" fxLayout="row" fxLayoutAlign="center center">
              <button mat-button class="accent-100" color="warn" *ngIf="langNat.length == 0"  (click)="openDialog('1')">
                {{'CERTIFICAR.IDIOMAS.ELEGIR' | translate}}
              </button>
              <button mat-button class="accent-100" color="warn" *ngIf="langNat.length > 0"  (click)="openDialog('x')">
                {{'CERTIFICAR.IDIOMAS.ELEGIR' | translate}}
              </button>
            </div>

            <!------- boton elegir idioma adicional --------->
            <div *ngIf="i == 1 && !sinAdic" class="footer" fxLayout="row" fxLayoutAlign="center center">
              <button mat-button class="accent-100" color="warn" (click)="openDialog('2')">
                {{'CERTIFICAR.IDIOMAS.ELEGIR' | translate}}
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-----------boton finalizar paso---------->
    <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
      <button *ngIf="!pasoCompleto && !cargando" (click)="completarPaso()" mat-fab aria-label="boton completar paso"
        matTooltip="{{'CERTIFICAR.IDIOMAS.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20"
        (click)="completarPaso()"
      >
        <mat-icon>done</mat-icon>
      </button>
      <button *ngIf="pasoCompleto && !cargando" (click)="completarPaso()" mat-raised-button class="done mr-20">
        {{'CERTIFICAR.IDIOMAS.STATUS.DONE' | translate}}
        <mat-icon class="ml-20">done</mat-icon>
      </button>
    </div>
  </div>


<!------- cards----------->
